require('./dist/badge/badge.css');
